<script lang="ts" module>
  import { DateTime, parseStandardTime } from '@yp/common/time.ts';
  const defaultTime = DateTime.local(0, 0, 0, 8, 30);
</script>

<script lang="ts">
  import type { ButtonProps } from './Button.svelte';
  import Button from './Button.svelte';

  interface Props extends Omit<ButtonProps, 'value'> {
    value: DateTime;
  }

  let {
    id,
    value = $bindable(defaultTime),
    class: clazz,
    // N.B. children was supposed to be passed to button to allow custom rendering of the display,
    // but that doesn't seem feasible on Safari while still allowing showPicker() to work.
    children,
    ...extraProps
  }: Props = $props();

  function toTime() {
    return value.toLocaleString(DateTime.TIME_24_SIMPLE);
  }
  function fromTime(v: string) {
    value = parseStandardTime(v);
  }
</script>

<Button
  {id}
  tag="input"
  type="time"
  step={300}
  value={toTime()}
  oninput={(e) => fromTime(e.target.value)}
  {...extraProps}></Button>

<style lang="scss">
  :root :global(input[type='time']) {
    position: relative;
  }
  :root :global(input[type='time']::-webkit-datetime-edit) {
    justify-content: center;
  }
  :root :global(input[type='time']::-webkit-inner-spin-button),
  :root :global(input[type='time']::-webkit-calendar-picker-indicator) {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    background: transparent; // Hides the default icon, allowing the input background to show
    cursor: pointer; // Indicates clickable area
    // display: none;
    // -webkit-appearance: none;
  }
</style>
